import {getGoodsByDeliver, formatGoods} from './goods/index';
import {getProduct} from './services/index';


// 全局注册
if(window) {
  if(!window.$ACE) {
    window.$ACE = {};
  }

  window.$ACE.GoodsService = {getGoodsByDeliver, formatGoods, getProduct};
}

export {getGoodsByDeliver, formatGoods, getProduct};


// WEBPACK FOOTER //
// ./lib/index.js